module.exports = __webpack_public_path__ + "static/media/greninja_0.2b4ef4c9.png";